import React, { useState, useEffect } from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import moment from "moment";
import ManaMinutesDuration from "../ManaMinutesDuration";

export default function TimePickerSwipeHeader(props) {
  const { timeslot, style } = props;

  const [selectedDate, setSelectedDate] = useState("");
  const [warningsHeaderStyle, setWarningsHeaderStyle] = useState({});
  const [durationMinutes, setDurationMinutes] = useState(null);
  const { startTime, endTime } = timeslot;

  // ------------------------------------- DURATION -------------------------------------
  useEffect(() => {
    const { time: startDate, endDate } = timeslot;
    const start = moment(startDate);
    const end = moment(endDate);

    if (end.isBefore(start)) end.add(1, "days");

    // Selected date
    const startDateStr = start.format("ddd, MMM DD");
    const endDateStr = end.format("ddd, MMM DD");
    if (startDateStr == endDateStr) {
      setSelectedDate(startDateStr);
    } else {
      setSelectedDate(`${startDateStr} - ${endDateStr}`);
    }

    // Duration
    const diff = end.diff(start, "minutes");
    const hours = Math.floor(diff / 60);

    setWarningsHeaderStyle(hours >= 10 ? styles.warning : {});
    setDurationMinutes(diff);
  }, [startTime, endTime]);

  return (
    <View style={[styles.header, warningsHeaderStyle, style]}>
      <View style={styles.durationContainer}>
        <Text style={styles.time}>{startTime}</Text>
        <Text style={styles.time}>-</Text>
        <Text style={styles.time}>{endTime}</Text>

        {/* Duration */}
        <ManaMinutesDuration
          minutes={durationMinutes}
          showBraces={durationMinutes > 0}
        />
      </View>

      <View>
        <Text style={styles.selectedDate}>{selectedDate}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  durationContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  time: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#2D3142",
    marginRight: 5,
  },
  selectedDate: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: "#2D3142",
  },
  warning: {
    backgroundColor: "#F6EC91",
  },
});
